import React, { ReactNode } from "react";
import Box from "react-raster";
import { ITooltipProps, Tooltip } from "src/components";
import { theme } from "src/config";
import styled from "styled-components";


export interface IEmptyCardProps {
  children?:     JSX.Element;
  icon?:         ReactNode;    /* single icon or left icon */
  tooltip?:      ReactNode;
  disableHover?: boolean;
  onClick? ():   void;         /* single icon onClick */
  rightProps?: {
    icon?:     ReactNode;
    tooltip?:  string;
    onClick(): void;
  }
}

const Container = styled<any>(Box)`
  position: relative;
  :hover {
    background: ${props => props.split ? undefined : `${theme.color.hover}`};
  }
`;

const SplitContainer = styled.div`
  position:       absolute;
  display:        flex;
  width:          100%;
  height:         100%;
  flex-direction: row;
`;

const SplitSide = styled.div`
  width:           50%;

  :hover {
    background: ${theme.color.hover};
  }
`;

const BorderSpacer = styled.div`
  display:      flex;
  width:        0;
  border-right: 1px ${theme.color.secondaryBorder} dashed;
  margin:       0.5rem 0;
`;

const StyledTooltip = styled(Tooltip)`
  width: 100%;
  height: 100%;

  display:         flex;
  align-items:     center;
  justify-content: center;
`

const EmptyWrapper = ({ children }: { children: JSX.Element; content: ReactNode; }) => children;

export const EmptyCard = (props: IEmptyCardProps): JSX.Element => {
  const border = `1px ${theme.color.primaryBorder} solid`;

  const { rightProps, disableHover } = props;
  const split: boolean = rightProps !== undefined

  const Wrapper = split || !props.tooltip ? EmptyWrapper : Tooltip

  return (
    <Wrapper content={props.tooltip}>
      <Container
        className     = "settings_card"
        colspan       = {3}
        cursor        = {"pointer"}
        width         = {"22rem"}
        height        = {"12rem"}
        gridRowGap    = {"0"}
        gridColumnGap = {"0"}
        onClick       = {split ? undefined : props.onClick}
        split         = {+(Boolean(split || disableHover))} // The + is necessary to prevent a styled component warning
      >
        <Box cols={1} borderLeft={border} borderTop={border} style={{borderRadius: "4px 0 0 0", marginRight: 0}}></Box>
        <Box cols={1} style={{marginRight: 0}} ></Box>
        <Box cols={1} borderTop={border} borderRight={border} style={{borderRadius: "0 4px 0 0", marginRight: 0}}></Box>
        <Box cols={1} style={{marginRight: 0}} ></Box>
        <Box
          cols           = {1}
          style          = {{marginRight: 0}}
          display        = "flex"
          alignItems     = "center"
          justifyContent = "center"
          overflow       = "visible"
          width          = "undefined"
        >
          {!split && (props.icon || props.children)}
        </Box>
        <Box cols={1} style={{marginRight: 0}} ></Box>
        <Box cols={1} borderLeft={border} borderBottom={border} style={{borderRadius: "0 0 0 4px", marginRight: 0}}></Box>
        <Box cols={1} style={{marginRight: 0}} ></Box>
        <Box cols={1} borderRight={border} borderBottom={border} style={{borderRadius: "0 0 4px 0", marginRight: 0}}></Box>
        {split && rightProps !== undefined &&
          <SplitContainer>  
            <SplitSide onClick={props.onClick}>
              <StyledTooltip content={props.tooltip}>
                {props.icon}
              </StyledTooltip>
            </SplitSide>
            <BorderSpacer/>
            <SplitSide onClick={rightProps.onClick}>
              <StyledTooltip content={rightProps.tooltip} >
              {rightProps.icon}
              </StyledTooltip>
            </SplitSide>
          </SplitContainer>
        }
      </Container>
    </Wrapper>
  );
}